/* CONFIG */
export const RECEIVE_CONFIG = 'RECEIVE_CONFIG';
export const RECEIVE_CONFIG_THEME = 'RECEIVE_CONFIG_THEME';

/* AUTHENTICATION */
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_ERROR = 'AUTH_ERROR';
export const AUTH_READY = 'AUTH_READY';

/* API DICTIONARIES */
export const RECEIVE_PARTNERS_DICTIONARY    = 'RECEIVE_PARTNERS_DICTIONARY';
export const RECEIVE_ADVERTISERS_DICTIONARY = 'RECEIVE_ADVERTISERS_DICTIONARY';
export const RECEIVE_USERS_DICTIONARY = 'RECEIVE_USERS_DICTIONARY';
export const RECEIVE_USER_ROLES_DICTIONARY  = 'RECEIVE_USER_ROLES_DICTIONARY ';
export const RECEIVE_EVENT_TYPES_DICT = 'RECEIVE_EVENT_TYPES_DICT';
export const RECEIVE_EVENT_TYPES_EXTENDED_DICT = 'RECEIVE_EVENT_TYPES_EXTENDED_DICT';
export const RECEIVE_EVENT_TYPES_DICT_TIMESTAMP = 'RECEIVE_EVENT_TYPES_DICT_TIMESTAMP';
export const RECEIVE_EVENT_TYPES_EXTENDED_DICT_TIMESTAMP = 'RECEIVE_EVENT_TYPES_EXTENDED_DICT_TIMESTAMP';
export const RECEIVE_VIRTUAL_EVENT_TYPES = 'RECEIVE_VIRTUAL_EVENT_TYPES';
export const RECEIVE_TIMEZONES_DICT = 'RECEIVE_TIMEZONES_DICT';
export const RECEIVE_COUNTRIES_DICT = 'RECEIVE_COUNTRIES_DICT';
export const RECEIVE_TRACKING_PARAMS_DICT = 'RECEIVE_TRACKING_PARAMS_DICT';
export const RECEIVE_CLICKTAG_PARAMS_DICT = 'RECEIVE_CLICKTAG_PARAMS_DICT';
export const RECEIVE_CATEGORIES_DICT = 'RECEIVE_CATEGORIES_DICT';
export const RECEIVE_CURRENCIES_DICT = 'RECEIVE_CURRENCIES_DICT';
export const RECEIVE_CURRENCIES_DICT_TIMESTAMP = 'RECEIVE_CURRENCIES_DICT_TIMESTAMP';
export const RECEIVE_ISPS_DICTIONARY = 'RECEIVE_ISPS_DICTIONARY';
export const RECEIVE_FRAUD_REASONS_DICT = 'RECEIVE_FRAUD_REASONS_DICT';
export const RECEIVE_OS_DICT = 'RECEIVE_OS_DICT';
export const RECEIVE_IMPRESSION_TRACKING_PARAMS_DICT = 'RECEIVE_IMPRESSION_TRACKING_PARAMS_DICT';

/* TAGS */
export const RECEIVE_TAGS_ISPS = 'RECEIVE_TAGS_ISPS';
export const RECEIVE_TAGS_BILLINGSTATE = 'RECEIVE_TAGS_BILLINGSTATE';
export const RECEIVE_TAGS_ORDERSTATE = 'RECEIVE_TAGS_ORDERSTATE';
export const RECEIVE_TAGS_BILLINGCONTEXT = 'RECEIVE_TAGS_BILLINGCONTEXT';
export const RECEIVE_TAGS_CLICK_PARAM_NAMES = 'RECEIVE_TAGS_CLICK_PARAM_NAMES';
export const RECEIVE_TAGS_EVENT_PARAM_NAMES = 'RECEIVE_TAGS_EVENT_PARAM_NAMES';
export const RECEIVE_TAGS_UPYIELD_PARAM_NAMES = 'RECEIVE_TAGS_UPYIELD_PARAM_NAMES';

export const RECEIVE_PAYOUTS            = 'RECEIVE_PAYOUTS';
export const RECEIVE_PAYOUT             = 'RECEIVE_PAYOUT';

export const SAVE_CLICKS_REPORT_FILTERS = 'SAVE_CLICKS_REPORT_FILTERS';
export const SAVE_EVENTS_REPORT_FILTERS = 'SAVE_EVENTS_REPORT_FILTERS';

/* OFFERS */
export const SAVE_OFFER_PARTNERS_FILTERS  = 'SAVE_OFFER_PARTNERS_FILTERS';
export const SAVE_OFFER_FORM_PARTNERS_FILTERS = 'SAVE_OFFER_FORM_PARTNERS_FILTERS';
export const SAVE_OFFER_BANNERS_FILTERS  = 'SAVE_OFFER_BANNERS_FILTERS';
export const RECEIVE_OFFER              = 'RECEIVE_OFFER';
export const RECEIVE_OFFER_BANNERS      = 'RECEIVE_OFFER_BANNERS';
export const RECEIVE_OFFER_CAMPAIGNS    = 'RECEIVE_OFFER_CAMPAIGNS';
export const RECEIVE_OFFERS_DICTIONARY      = 'RECEIVE_OFFERS_DICTIONARY';
export const RECEIVE_OFFER_ALERTS           = 'RECEIVE_OFFER_ALLERTS';
export const RESET_OFFER_STATE              = 'RESET_OFFER_STATE';

export const RECEIVE_DICTIONARIES       = 'RECEIVE_DICTIONARIES';


/* PROFILE */
export const RECEIVE_CURRENT_USER            = 'RECEIVE_CURRENT_USER';
export const RECEIVE_CURRENT_USER_TIMEFRAME  = 'RECEIVE_CURRENT_USER_TIMEFRAME';
export const RESET_CURRENT_USER              = 'RESET_CURRENT_USER';
export const RECEIVE_SUBSCRIPTION_COST_CHART = 'RECEIVE_SUBSCRIPTION_COST_CHART';
export const RECEIVES_SUBSCRIPTION_INFO      = 'RECEIVES_SUBSCRIPTION_INFO';

/* Messages */
export const RECEIVE_MESSAGE_PARAMS = 'RECEIVE_MESSAGE_PARAMS';

/* PASSWORD */
export const SEND_RESET_PASSWORD_LINK_ERROR = 'SEND_RESET_PASSWORD_LINK_ERROR';
export const SET_NEW_PASSWORD_ERROR = 'SET_NEW_PASSWORD_ERROR';

/* CURRENT USER PRIVILEGES */
export const UPDATE_CURRENT_USER_PRIVILEGES = 'UPDATE_CURRENT_USER_PRIVILEGES';
export const POPULATE_CURRENT_USER_PRIVILEGES = 'POPULATE_CURRENT_USER_PRIVILEGES';
export const POPULATE_CURRENT_USER_MODULES_RESTRICTIONS = 'POPULATE_CURRENT_USER_MODULES_RESTRICTIONS';
